import script from "./RemoteMeetings.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoteMeetings.vue?vue&type=script&setup=true&lang=ts"

import "./RemoteMeetings.vue?vue&type=style&index=0&id=be301880&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be301880"]])

export default __exports__